import { FullHubspotCompany } from '@types'

export const validateHubspotUsers = (
  hubspotCompany: FullHubspotCompany,
  flashError: (message: string) => void,
  flashWarning: (message: string) => void,
) => {
  const errorUsers = []
  const warningUsers = []

  const { accountExecutive, clientSuccessManager, sdrUser } = hubspotCompany

  if (!accountExecutive) {
    errorUsers.push('Account Executive (HubSpot Owner) - Missing In HubSpot')
  } else if (!accountExecutive.hungryUserId) {
    errorUsers.push(
      `Account Executive (HubSpot Owner) - No HUNGRY user matching HubSpot user ${accountExecutive.email}`,
    )
  }
  if (!clientSuccessManager) {
    errorUsers.push('Client Success Manager - Missing In HubSpot')
  } else if (!clientSuccessManager.hungryUserId) {
    errorUsers.push(
      `Client Success Manager - No HUNGRY user matching HubSpot user ${clientSuccessManager.email}`,
    )
  }
  if (!sdrUser) {
    warningUsers.push('SDR - Missing In HubSpot')
  } else if (!sdrUser.hungryUserId) {
    warningUsers.push(
      `SDR - No HUNGRY user matching HubSpot user ${sdrUser.email}`,
    )
  }

  const isError = errorUsers.length > 0
  if ([...errorUsers, ...warningUsers].length > 0) {
    const errMsg =
      `The following users could not be assigned from HubSpot${
        !isError ? ', but the account is still valid to save' : ''
      }:\n` +
      '• ' +
      [...errorUsers, ...warningUsers].join('.\n• ') +
      '.'
    isError ? flashError(errMsg) : flashWarning(errMsg)
  }

  return isError
}
